<footer class="site-footer" role="contentinfo">
  <div class="site-footer-inner">
    <div class="site-footer-copy">
      © {{ currentYear }} Project Brendan. All rights reserved.
    </div>
  </div>
</footer>
